export default __webpack_public_path__ + "static/media/Red0007.089e22d8.png";